import { brand, chartNeutrals, chartNeutralsLight, semantic, text, surfaces, lightText, lightSurfaces } from '@locaveri/shared';
export { brand, chartNeutrals, chartNeutralsLight, lightSurfaces, lightText, radius, semantic, semanticLight, shadows, surfaces, text, tokens, typography } from '@locaveri/shared';

// src/index.ts
var CHART_PRIMARY = brand[500];
var CHART_NEUTRALS_DARK = chartNeutrals;
var CHART_NEUTRALS_LIGHT = chartNeutralsLight;
var CHART_SERIES_DARK = [CHART_PRIMARY, ...CHART_NEUTRALS_DARK];
var CHART_SERIES_LIGHT = [CHART_PRIMARY, ...CHART_NEUTRALS_LIGHT];
var CHART_SEMANTIC = {
  success: semantic.success,
  warning: semantic.warning,
  danger: semantic.danger,
  info: semantic.info
};
var DARK_THEME = {
  mode: "dark",
  series: CHART_SERIES_DARK,
  primary: CHART_PRIMARY,
  grid: surfaces.border,
  axis: text.muted,
  label: text.secondary,
  tooltipBackground: surfaces.elevated,
  tooltipBorder: surfaces.borderStrong,
  tooltipForeground: text.primary,
  highlightFill: "rgb(235 205 9 / 0.12)"
};
var LIGHT_THEME = {
  mode: "light",
  series: CHART_SERIES_LIGHT,
  primary: CHART_PRIMARY,
  grid: lightSurfaces.border,
  axis: lightText.muted,
  label: lightText.secondary,
  tooltipBackground: lightSurfaces.surface,
  tooltipBorder: lightSurfaces.border,
  tooltipForeground: lightText.primary,
  highlightFill: "rgb(235 205 9 / 0.18)"
};
function chartTheme(mode = "dark") {
  return mode === "light" ? LIGHT_THEME : DARK_THEME;
}
function chartSeriesColor(index, mode = "dark") {
  if (!Number.isInteger(index) || index < 0) {
    throw new RangeError("\xCDndice de s\xE9rie inv\xE1lido: use um inteiro maior ou igual a zero.");
  }
  const palette = chartTheme(mode).series;
  const color = palette[index % palette.length];
  if (color === void 0) {
    throw new RangeError("Paleta de gr\xE1fico vazia.");
  }
  return color;
}
function chartSeriesColors(count, mode = "dark") {
  if (!Number.isInteger(count) || count < 0) {
    throw new RangeError("Quantidade de s\xE9ries inv\xE1lida: use um inteiro maior ou igual a zero.");
  }
  return Array.from({ length: count }, (_unused, index) => chartSeriesColor(index, mode));
}

// src/index.ts
var MONEY_CELL_CLASS = "money-cell";
var TABULAR_MONEY_CLASS = "tabular-money";
var NUMERIC_DISPLAY_CLASS = "numeric-display";
var LIGHT_THEME_CLASS = "light";

export { CHART_NEUTRALS_DARK, CHART_NEUTRALS_LIGHT, CHART_PRIMARY, CHART_SEMANTIC, CHART_SERIES_DARK, CHART_SERIES_LIGHT, LIGHT_THEME_CLASS, MONEY_CELL_CLASS, NUMERIC_DISPLAY_CLASS, TABULAR_MONEY_CLASS, chartSeriesColor, chartSeriesColors, chartTheme };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map